import { testimonials } from "../../../../globals/neuron-content";

function SectionTestimonials2() {
  return (
    <div className="sx-testimonial-bx-2 m-b30">
      <div className="section-head center">
        <div className="sx-head-s-title">Client Confidence</div>
        <div className="sx-head-l-title"><h2 className="sx-title">What Clients Value</h2></div>
      </div>
      <div className="owl-carousel testimonial-section-2 owl-btn-vertical-center">
        {testimonials.map((item) => (
          <div className="item" key={item.name}>
            <div className="testimonial-1 hover-animation-1 sx-bg-white">
              <div className="testimonial-detail">
                <div className="testimonial-user-info">
                  <span className="testimonial-position">{item.position}</span>
                  <h4 className="testimonial-name">{item.name}</h4>
                </div>
              </div>
              <div className="testimonial-text"><p>{item.text}</p></div>
              <div className="testimonial-footer">
                <div className="testimonial-quote sx-text-primary"><i className="flaticon-quote" /></div>
                <ul className="sx-rating-st1"><li><span><i className="fa fa-star" /></span></li><li><span><i className="fa fa-star" /></span></li><li><span><i className="fa fa-star" /></span></li><li><span><i className="fa fa-star" /></span></li><li><span><i className="fa fa-star" /></span></li></ul>
                <span className="sx-review-count">(Verified)</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SectionTestimonials2;
